export { default } from './BaseInput';
